module.exports = __webpack_public_path__ + "static/media/Kitchen.ba8ede57.webp";